
import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';

import { GurdServiceService } from "src/app/Service/gurd-service.service";

declare let $: any;

@Component({

  selector: 'app-absence-to-school',

  templateUrl: './absence-to-school.component.html',

  styleUrls: ['./absence-to-school.component.css'],

  animations: [

    trigger('fadeAnimation', [

      state('void', style({ opacity: 0 })),

      transition(':enter', [

        animate('300ms ease-in', style({ opacity: 1 }))

      ]),

      transition(':leave', [

        animate('100ms ease-out', style({ opacity: 0 }))

      ])

    ])

  ]

})

export class AbsenceToSchoolComponent implements OnInit {

  list_Schools: any = [];

  list_Students: any = [];

  list_Absence = [];

  list_search = [];

  filteredSchools = [];

  filteredStudents = [];

  lstPassenger: any = [];

  searchT_School = '';

  searchT_Student = '';

  iPassenger!: number | string;

  iMobileDomain!: number;

  studentData: any;

  map: any;

  source: any;

  source2: any;

  vector: any;

  vector2: any;

  layers: any = [];

  layers2: any = [];

  isLoading: boolean = false;

  showFilter: boolean = false;

  bMedical: boolean = false;

  dateFilter: FormGroup = this.FormBuilder.group({

    fromDate: new FormControl(''),

    toDate: new FormControl(''),

  })

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  constructor(

    private router: Router,

    private FormBuilder: FormBuilder,

    private Notification: NotificationService,

    private gurdService: GurdServiceService,

    private _other: OtherService,

    private _tooltip: NotificationService

  ) { }

  ngOnInit(): void {

    this.getSchools();


  }

  goBack() {

    this.router.navigate(['/'])

  }

  onStudent_selected(item: any) {

    this.searchT_Student = item.strPassenger_FullName;

    this.iPassenger = item.iPassenger

    this.filteredStudents = [];


  }

  showOnMap(item: any) {

    $('#stdLocation').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });


      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }



      this.map = new Map({

        layers: this.layers,

        target: 'map',

        view: new View({

          center: olProj.fromLonLat([item.fOriginLon, item.fOrigiLat]),

          zoom: 13,

        }),

      });

    }, 500);

  }

  message_Modal() {

    if (this.lstPassenger.length == 0) return this.Notification.showError('لطفا دانش آموز مورد نظر خود را انتخاب کنید');

    $('#sendMessage').modal('show')
  }

  setCheckBox(value: boolean, item: any) {

    if (value === true) this.lstPassenger.push(item.iPassenger);

    else {

      this.lstPassenger.find((value: any) => {

        if (value === item.iPassenger) {

          const index = this.lstPassenger.indexOf(item.iPassenger);

          if (index !== -1) this.lstPassenger.splice(index, 1);

        }

      })
    }

  }

  isSelected(item: any): boolean {

    return this.lstPassenger.indexOf(item) !== -1;
  }

  selectAllCheckBox() {

    if (this.list_Absence.length > 0 && (this.list_Absence.length != this.lstPassenger.length)) {

      this.lstPassenger = [];

      this.list_Absence.forEach((a: any) => {

        this.lstPassenger.push(a.iPassenger);

      })

      this.Notification.showSuccess('همه دانش آموزان انتخاب شدند')

    }

    else {

      this.lstPassenger = [];

    }

  }

  async sendMessage(form: NgForm) {

    if (form.value.strMessage == '') return this.Notification.showError('لطفا متن پیام را مشخص کنید');

    if (!form.value.bSendPush && !form.value.bSaveMessage) return this.Notification.showError('لطفا نحوه ارسال پیام را مشخص کنید');

    form.value['iSystemUser'] = this.gurdService.decrypt(localStorage.getItem('ID')!);

    form.value['strSession'] = this.gurdService.decrypt(localStorage.getItem('Session')!);

    form.value['lstPassenger'] = this.lstPassenger;

    let res = JSON.parse((await axios.post(`School_Passenger_SendMessage`, form.value)).data.toString());

    if (res.iResult) {

      $('#sendMessage').modal('hide');

      return this.Notification.showSuccess('پیام با موفقیت ارسال شد');
    }

    else return this.Notification.showError(res.strError)


  }

  async getSchools() {

    this._other.Showspinner();

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString())

    this.list_Schools = res;

    this._other.nonespinner();


  }

  async getStudent(item: any) {

    this._other.Showspinner();

    this.list_Students = [];

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strMobile: '',

      strFullName: '',

      tiSex: -1,

      iMobileDomain: this.iMobileDomain = item.iMobileDomain
    }

    let res = JSON.parse((await axios.post(`School_Passenger_List`, model)).data.toString());

    this._other.nonespinner();

    this.list_Students = res;


  }

  async search_student() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strSDate: this.dateFilter.value.fromDate,

      strEDate: this.dateFilter.value.toDate,

      iPassenger: this.iPassenger != undefined ? this.iPassenger : -1,

      iMobileDomain: this.iMobileDomain != undefined ? this.iMobileDomain : -1,

      bSchool: true

    }

    let res = JSON.parse((await axios.post(`School_Absence_List`, model)).data.toString())

    this.list_Absence = res;

    this.list_search = res;

    this.isLoading = false;

  }

  async showDetail(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iPassenger: item.iPassenger

    }

    let res = JSON.parse((await axios.post(`School_Passenger_Info`, model)).data.toString());

    item.fDistance = res[0].fDistance;

    item.strName = res[0].strName;

    item.strFamily = res[0].strFamily;

    item.strNationalCode = res[0].strNationalCode.trim();

    item.strAvatar = '';

    this.studentData = item;

    $('#detailModal').modal('show');


  }

  async showImageDetail(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iSchool_Absence: item.iSchool_Absence

    }

    this._other.Showspinner();

    let res = JSON.parse((await axios.post(`School_Absence_Info`, model)).data.toString());

    this._other.nonespinner();

    if (res.bError || res.iResult == 0) return this.Notification.showError(res.strError)

    if (res[0].strImage == "") return this._tooltip.showError('محتوایی یافت نشد');

    this.studentData = res[0];

    this.bMedical = true;

    $('#detailModal').modal('show');


    // ططططططططططططططططططططططططططططططططط

  }

  sortBy(input: number) {

    this.list_Absence.sort((a: any, b: any) => {

      switch (input) {

        case 0:
          var textA = a.strDate.toUpperCase();
          var textB = b.strDate.toUpperCase();
          break;

        case 1:
          var textA = a.strPassenger_FullName.toUpperCase();
          var textB = b.strPassenger_FullName.toUpperCase();
          break;

        case 2:
          var textA = a.strMobileDomain_strComment.toUpperCase();
          var textB = b.strMobileDomain_strComment.toUpperCase();
          break;

      }

      if (textA > textB) return (textA < textB) ? 1 : (textA > textB) ? -1 : 0;

      if (textA < textB) return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;

      return 0;

    })
  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Absence = this.list_search.filter((el: any) => {

        return el.strDate.includes(search) || el.strPassenger_FullName.includes(search) || el.strMobileDomain_strComment.includes(search) || el.strStatus.includes(search)

      })
    }

    else if (search == '') this.list_Absence = this.list_search
  }

  exportExcel() {

    setTimeout(() => {

      let element = document.getElementById('Export_Excel');

      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, 'غیبت های دانش آموزان از مدرسه.xlsx');

    }, 200);

  }

  setValue_School(item: any) {

    if (item.strComment) {

      this.getStudent(item);

    }

    else {

      this.list_Students = [];

      this.iMobileDomain = -1;

      this.iPassenger = -1;

    }

  }

  setValue_Student(item: any) {

    if (item.iPassenger) {

      this.iPassenger = item.iPassenger

    }

    else {

      this.iPassenger = '';

    }

  }


}
